<template>
  <div>

    <!-- HEADER DASHBOARD E KPI -->
    <div class="pic-header">
      <b-row
        no-gutters
        align-v="center"
        class="flex-wrap px-4 py-3"
      >
        <!-- Titolo dashboard -->
        <b-col
          cols="12"
          lg="auto"
          class="mr-4 mb-3 mb-lg-0"
        >
          <div class="logo">
            <div class="wb-brand">
              Dashboard Welfare
            </div>
            <div class="sub">
              Analisi piani benefit e macrocategorie di spesa
            </div>
          </div>
        </b-col>

        <!-- KPI -->
        <b-col>
          <div class="kpi-wrapper">
            <div
              v-for="kpi in kpis"
              :key="kpi.label"
              class="hkpi"
            >
              <div class="hl">
                {{ kpi.label }}
              </div>
              <div class="hv">
                {{ kpi.value }}
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

   <!-- NAVIGAZIONE SEZIONI -->
    <div id="tabs">
      <div class="tabs-wrapper">
        <button
          class="tbtn"
          :class="{ active: activeTab === 'piani' }"
          @click="selectTab('piani')"
        >
          <b-icon
            icon="folder"
            class="tab-icon"
          />
          Piani
        </button>
        <button
          class="tbtn"
          :class="{ active: activeTab === 'macro' }"
          @click="selectTab('macro')"
        >
          <b-icon
            icon="bar-chart"
            class="tab-icon"
          />
          Macrocategorie di spesa
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import picService from "@/services/pic.service";
export default {
  name: "PICHeader",
  props: {
    activeTab: {
      type: String,
      default: "piani"
    }
  },

  data() {
    return {

      // KPI visualizzati nell'header
      kpis: [

        {
          label: "Piani",
          value: "-"
        },

        {
          label: "Caricato",
          value: "€ 0"
        },

        {
          label: "Speso",
          value: "€ 0"
        },

        {
          label: "% Utilizzo",
          value: "0%"
        },

        {
          label: "Fornitori convenzionati",
          value: 0
        }
      ]
    };
  },

  async created() {
      await this.caricaHeader();
    },

  methods: {

    async caricaHeader() {
        
        const response = await picService.getHeaderDashboard();

        const dati = response.data;

        this.kpis[0].value = dati.totale_piani;
        this.kpis[1].value = this.formatEuro(
          dati.totale_caricato
        );

        this.kpis[2].value = this.formatEuro(
          dati.totale_speso
        );

        this.kpis[3].value =
          `${Number(dati.percentuale_utilizzo).toFixed(2)}%`;

        this.kpis[4].value =
          dati.fornitori_convenzionati;
      },
      // Formatta l'importo in euro con separatore delle migliaia e due decimali
      formatEuro(valore) {
        const numero = new Intl.NumberFormat(
          "it-IT",
          { useGrouping: true,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        ).format(valore || 0);

      return `€ ${numero}`;
      },

    // Notifica al componente padre il cambio di tab
    selectTab(tab) {
      this.$emit("change-tab", tab);
    }
  }
};
</script>

<style scoped>

/* HEADER */

.pic-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background:#f4f6f9;
    color:#373F66;
    border:2px solid #dee2e6;
    border-radius:8px 8px 0 0;
}

/* LOGO */

.logo {
    line-height:1.2;
    /*alzo visivamente il logo per allinearlo esattamente con le kpi*/
    transform:translateY(-4px); 
}


.wb-brand {
    font-size:24px;
    font-weight:700;
    color:#373F66;
}

.sub {
    margin-top:2px;
    font-size:14px;
    color:#373F66;
}

/* KPI */

.kpi-wrapper {
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    justify-content:center;
    gap:24px;
    width:100%;
}

.hkpi {
    flex:1 1 130px;
    max-width:180px;
    min-width:130px;
    padding:8px 14px;
    text-align:center;
    border-radius:8px;
    background:white;
    border:2px solid #373F66;
    transition:all .2s;
}

.hkpi:hover {
    background:#e9ecf2;
}

.hl {
    font-size:10px;
    font-weight:600;
    text-transform:uppercase;
    color:#373F66;
}

.hv {
    font-size:16px;
    font-weight:700;
    color:#373F66;
}

/* TABS */

#tabs {
    background:#fff;
}

.tabs-wrapper {
    display:flex;
    align-items:center;
    padding:0;
}

.tbtn {
    padding:12px 24px;
    border:none;
    border-bottom:3px solid transparent;
    background:transparent;
    font-size:14px;
    font-weight:600;
    color:#666;
    cursor:pointer;
    transition:all .2s;
}


.tbtn:hover {
    background:rgba(55,63,102,.08);
    color:#373F66;
}

.tbtn:focus {
    outline:none;
    box-shadow:none;
}

.tbtn.active {
    background:rgba(55,63,102,.08);
    color:#373F66;
    border-bottom-color:#373F66;
    font-weight:700;
}

</style>